import { AdminLayout } from '@/components/layouts'
import { FaqItemForm } from './FaqItemForm'

interface Community {
  id: number
  name: string
}

interface NewProps {
  communities: Community[]
  max_position: number
}

export default function New({ communities, max_position }: NewProps) {
  return (
    <AdminLayout
      title="Nouvelle question FAQ"
      breadcrumbs={[
        { label: 'FAQ', href: '/admin/faq_items' },
        { label: 'Nouvelle question' }
      ]}
    >
      <div className="max-w-2xl">
        <FaqItemForm
          communities={communities}
          maxPosition={max_position}
          onSubmit="/admin/faq_items"
        />
      </div>
    </AdminLayout>
  )
}
